<template>
  <nav
    class="main-header navbar navbar-expand navbar-dark navbar-brand-variant"
    style="height: 3.58rem"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <a
          class="nav-link d-block d-md-none"
          id="sidebar-toggler"
          data-widget="pushmenu"
          href="#"
          role="button"
          @click.prevent="$emit('openMenu')"
          ><i class="fas fa-bars"></i
        ></a>
        <div
          class="menu-overlay"
          :class="{visible: isMenuOpen}"
          @click="$emit('closeMenu')"
        ></div>
      </li>

      <li class="nav-item">
        <p class="navbar-brand ml-3">
          <span class="brand-text font-weight-light">{{ settingsStore.title }}</span>
          <span
            class="text-sm text-white-50 header-subtitle"
            style="text-transform: uppercase"
          >
            {{ settingsStore.subtitle }}</span
          >
        </p>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import {mapState} from "pinia";
import useSettingsStore from "@/stores/settings.store.js";

const props = defineProps(['isMenuOpen']);
const emit = defineEmits(['openMenu', 'closeMenu']);
const settingsStore = useSettingsStore();
</script>

<style lang="scss">
nav.navbar-brand-variant {
  background: var(--accent-color);
}

.menu-overlay {
  display: none;
}
.menu-overlay.visible {
  display: block;
  position: fixed;
  inset: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 1;
}

@media (min-width: 768px) {
  .menu-overlay {
    display: none !important;
  }
}

</style>
